import store from "../store";

export default async function is_admins_and_senior_and_test_admin({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if ( (role !== 'mini-admin') && (role !== 'admin') && (role !== 'senior-retoucher') && (role !== 'test-admin') && (role !== 'tester') ) {
        return router.push({ name: "User Profile" });
    }

    return next();
}
